import * as React from "react";
import { GET_GROUPS } from "../../graphql/hooks/queries/useGetGroups";
import { Group } from "../../graphql/types";
import useInsertGroup from "../../hooks/useInsertGroup";
import useViewer from "../../hooks/useViewer";
import { Button, ModalActions, ModalBody, ModalHeader } from "../wombat-ui";
import Modal from "../wombat-ui/components/Modal/Modal";
import { InsertGroupForm } from "./InsertGroupForm";
import useTranslations from "../../hooks/useTranslations";
import useAddNotification from "../../hooks/useAddNotification";

interface InsertGroupDialogProps {
  group: Group;
  onClose: () => void;
}

export const InsertGroupDialog: React.FC<InsertGroupDialogProps> = ({
  group,
  onClose,
}) => {
  const [insertGroup] = useInsertGroup({
    refetchQueries: [
      { query: GET_GROUPS, variables: { q: group?.name } },
      { query: GET_GROUPS },
    ],
  });

  const [addNotification] = useAddNotification();
  const { company } = useViewer();
  const t = useTranslations();

  const submit = React.useCallback((data: Group) => {
    insertGroup({
      variables: {
        input: {
          ...data,
          companyId: company.id,
        },
      },
    })
      .then(() => {
        const action = data.id ? "update" : "create";
        addNotification({
          variables: {
            title: t(
              `groups.notification.success.${action}.title`
            ) as string,
            body: t(
              `groups.notification.success.${action}.body`
            ) as string,
            status: "success",
          },
        });
      })
      .then(onClose);
  }, []);

  return (
    <Modal isOpen={!!group}>
      <ModalHeader onClose={onClose}>{t("groups.add")}</ModalHeader>
      <ModalBody>
        <InsertGroupForm group={group} submit={submit} />
      </ModalBody>
      <ModalActions>
        <Button variant="subtle" onClick={onClose}>
          {t("forms.actions.cancel")}
        </Button>
        <Button type="submit" form="insertGroupForm">
          {t("forms.actions.save")}
        </Button>
      </ModalActions>
    </Modal>
  );
};
